import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import { Icon, Item } from 'semantic-ui-react';
import classnames from 'classnames';

import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { getHouseholdExceptionString } from '../../helpers/HouseholdExceptionHelpers';
import {
  getMemberType,
  MemberTypeEnum,
  getIconNameFromId,
  navigateToEditBasedOnId,
} from '../../helpers/Helpers';
import { EffectiveDate } from './EffectiveDate';

import 'PageStyles/manageapplication/index.less';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';

class MemberTable extends Component {
  onEdit = value => {
    navigateToEditBasedOnId(value.Id, this.props.familyId, this.props.history);
  };

  onDelete = value => {
    switch (getMemberType(value[Fields.Id])) {
      case MemberTypeEnum.Member:
      case MemberTypeEnum.HOH:
        this.props.deleteMember(value);
        break;

      case MemberTypeEnum.Student:
        this.props.deleteStudent(value[Fields.Id]);
        break;

      default:
        break;
    }
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: this.onEdit,
    },
    {
      icon: 'trash',
      text: 'Remove',
      className: 'danger',
      handler: this.onDelete,
    },
  ];

  columns = [
    {
      Header: <strong className={'text-orange'}>Household Members</strong>,
      columns: [
        {
          id: 'Icon',
          sortable: false,
          resizable: false,
          width: 35,
          style: { textAlign: 'center' },
          Cell: props => {
            const { memberData } = this.props;

            const emancipatedStudents = memberData
              ? memberData.filter(
                  y => y.Exceptions && y.Exceptions.IsEmancipatedMinor
                )
              : null;

            return (
              <Fragment>
                <Icon
                  color={
                    emancipatedStudents &&
                    emancipatedStudents.find(x => x.Id === props.original.Id)
                      ? 'blue'
                      : 'black'
                  }
                  name={getIconNameFromId(props.original.Id)}
                />
              </Fragment>
            );
          },
        },
        {
          Header: 'Name',
          sortable: true,
          width: 200,
          Cell: props => {
            return (
              <Fragment>
                {props.original.FirstName} {props.original.LastName}
              </Fragment>
            );
          },
        },
        {
          Header: 'Student #',
          width: 110,
          accessor: Fields.Id,
          sortable: true,
          Cell: props => {
            return (
              <Fragment>
                {getMemberType(props.original.Id) === MemberTypeEnum.Student
                  ? props.original.Id
                  : null}
              </Fragment>
            );
          },
        },
        {
          Header: 'Grade',
          width: 50,
          accessor: Fields.GradeId,
          sortable: true,
        },
        {
          Header: 'Site',
          width: 80,
          accessor: Fields.SiteId,
          sortable: true,
        },
        {
          Header: (
            <Fragment>
              Current
              <br />
              Status
            </Fragment>
          ),
          width: 65,
          accessor: Fields.StatusCurrent,
          sortable: true,
          style: { textAlign: 'center' },
        },
        {
          Header: (
            <Fragment>
              Future
              <br />
              Status
            </Fragment>
          ),
          width: 65,
          accessor: Fields.StatusFuture,
          sortable: true,
          style: { textAlign: 'center' },
        },
        {
          Header: 'Effective Date',
          width: 110,
          accessor: Fields.EffectiveDate,
          sortable: true,
          Cell: ({ original }) => {
            return (
              <EffectiveDate
                onClick={this.props.onEffectiveDateClick}
                student={original}
              />
            );
          },
        },
        {
          Header: 'Additional Info',
          accessor: Fields.AdditionalInfo,
          sortable: true,
          resizable: false,
          Cell: props => {
            const { original: { Exceptions: exceptions } = {} } = props;
            const content =
              getHouseholdExceptionString(
                exceptions,
                this.props.caseTypeLookup
              ) || '';

            const containerClassName = classnames({
              'scroll-container': content.length > 30,
            });

            return (
              <div className={containerClassName}>
                <span className={'scroll-content'}>{content}</span>
              </div>
            );
          },
        },
        {
          accessor: Fields.EmancipatedStudentId,
          show: false,
        },
        {
          id: 'Menu',
          style: { textAlign: 'center' },
          Cell: gridProps => {
            if (
              this.props.isReadOnly ||
              gridProps.original[Fields.EmancipatedStudentId]
            ) {
              return null;
            }

            return GridContextMenu({ gridProps, options: this.menuOptions });
          },
          width: 40,
          sortable: false,
        },
      ],
    },
  ];

  openAddStudent = () => {
    this.props.history.push(
      `/manageapplication/${this.props.familyId}/studentlookup`
    );
  };

  render() {
    return (
      <ReactTable
        className={
          'members-table grid--fixed-row-height grid--centered-headers'
        }
        columns={this.columns}
        data={this.props.memberData}
        loading={false}
        minRows={5}
        pageSize={5}
        showPageJump={false}
        showPageSizeOptions={false}
        filterable={false}
        noDataText={
          <Item
            as={'a'}
            className="table-add-student-link"
            onClick={this.openAddStudent}
          >
            Add Student
          </Item>
        }
      />
    );
  }
}

export { MemberTable };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/components/hub/MemberTable.js